<div class="flex-col">
  @for (r of currentQuestion.QuestionAnswers; track r) {
    <div
      class="mt-2 border-solid border-[1px] border-green-400 bg-standardwhite rounded-md flex p-2  align-middle"
      (click)="updateAnswer(r)">
      <input class="checked:bg-green-300 text-green-400 accent-transparent self-center" [id]="uniqueQuestionID"
        [checked]="r.SelectedOption" [name]="currentQuestion.GUID" type="radio" (change)="updateAnswer(r)" />
        <label class="ml-4">{{r.Description}}</label>
      </div>
    }
    @if (currentQuestion.AllowNA) {
      <div class="w-full border-t-[1px] border-t-grey-500 my-2">
      </div>
    }
    @if (currentQuestion.AllowNA) {
      <div (click)="selectNA()" class="mt-4 border-solid border-[1px] border-grey-900  bg-standardwhite rounded-md flex p-2  align-middle" >
        <input #naInput class="checked:bg-green-300  text-green-400 accent-transparent self-center" [id]="naSelectedID"
          [(ngModel)]="currentQuestion.NASelected" type="radio" (change)="naAnswer()" (click)="$event.stopPropagation()" />
          <label class="ml-4 text-sm" [for]="naSelectedID" (click)="$event.stopPropagation()">Not Applicable</label>
        </div>
      }
    </div>